/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useMemo, useState, useCallback, useRef} from 'react'
import debounce from 'debounce'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {BedBookingModel, BedsBookingDto} from '../../../../models/booking.model'
import {
  deleteBookingBedService,
  getBedsFromBookingService2,
  updateReserveDetail,
  updateReserveGuestBed,
} from '../../../../services/booking.service'

import {SnackbarProvider} from 'notistack'
// import {Select} from '../../../../../../components/UI/Select'
import Select from 'react-select'
import AsyncSelect from 'react-select/async'

import Swal from 'sweetalert2'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {SelectOption} from '../../../../../../models/utility.model'
import {getSnackBarToast} from '../../../../../../util/snackBar'
import {useBed} from '../../../../hooks/useBed'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {useModules} from '../../../../hooks/useModules'
import {useRooms} from '../../../../hooks/useRooms'
import {getListCampsGuestService} from '../../../../services/cancel-change.service'
import {paginationGuestsService} from '../../../guests/services'

const TableBookingDetails: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    updateTableDetail,
    setUpdateTableDetail,
    clearTableDetail,
    setClearTableDetail,
    selected,
    clearSelected,
  } = useKTable()
  const {changeCurrentTabItem, currentTabItem} = useHoteleria()
  const {searchValuesDetail, clearSearchValuesDetail} = useKhipu()
  const [bedTypes, setBedTypes] = useState<SelectOption[] | any>([])
  const [roomType, setRoomType] = useState<SelectOption[]>([])
  const [documentTypes, setDocumentTypes] = useState<SelectOption[]>([])
  const [turns, setTurns] = useState<SelectOption[]>([{value: '', label: 'CUALQUIERA'}])
  const [receptionistComp, setReceptionistComp] = useState<SelectOption[]>([
    {value: '', label: 'CUALQUIERA'},
  ])
  const [statusType, setStatusType] = useState<SelectOption[]>([])
  const [selectedBookings, setSelectedBookings] = useState<any[]>([])
  const [campsFilter, setCampsFilter] = useState<SelectOption[]>([])

  interface OptionType {
    value: string
    label: string
  }
  const {getMasterTable, getDocumentTypesByCode, getReceptionist, getCamps} = useCentralServices()
  const {getModulesAvailable} = useModules()
  const {getRoomsAvailable} = useRooms()
  const {getBedsAvailable} = useBed()

  const getBedBookings = async () => {
    try {
      setLoading(true)
      const {data: response} = await getBedsFromBookingService2({
        ReservaId: currentTabItem.idToEdit as any,
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...searchValuesDetail,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const getBedTypesFn = async () => {
    const data = await getMasterTable('TipoCama', true)
    setBedTypes(data)
  }

  const getRoomsTypeFn = async () => {
    const data = await getMasterTable('TipoHabitacion', true)
    setRoomType(data)
  }

  const getDocumentTypesFn = async () => {
    const data = await getDocumentTypesByCode()
    setDocumentTypes(data)
  }

  const getTurnsFn = async () => {
    const data = await getMasterTable('Turno', true)
    const allData = [{value: '', label: 'CUALQUIERA'}, ...data]
    setTurns(allData)
  }

  const getReceptionistFn = async (clienteId: any, companiaId: any) => {
    const data = await getReceptionist(
      {clienteId: clienteId || null, companiaId: companiaId || null, isCombo: true},
      1,
      true,
    )
    const allData = [{value: '', label: 'CUALQUIERA'}, ...data]
    setReceptionistComp(allData)
  }

  const getStatusTypesFn = async () => {
    const data = await getMasterTable('EstadoReservaCamaHuesped', true)
    setStatusType(data)
  }

  const style = {
    container: (base: any) => ({
      ...base,
      width: '100%',
    }),
    menu: (base: any) => ({
      ...base,
      zIndex: 9999,
      position: 'relative',
      top: 0,
      left: 0,
    }),
    control: (base: any) => ({
      ...base,
      borderColor: '#e2ebf6',
    }),
  }

  const handleChangeGuest = async (guest: any, reserve: BedBookingModel) => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: `Asignarás el huésped ${guest.label} a la reserva`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, asignar',
      confirmButtonColor: 'var(--kt-primary)',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true)
        try {
          let dtoReserveGuest: BedsBookingDto = {
            ReservaId: reserve.ReservaId,
            CamaId: reserve.CamaId,
            HuespedId: guest.value,
          }
          const data = await updateReserveGuestBed(dtoReserveGuest)
          if (!data.data.error) {
            getBedBookings()
            setSelectedBookings([])
            clearSelected()
            getSnackBarToast('Se asignó con éxito', 'success')
            const obj: TabModel = {
              ...currentTabItem,
              loadingTable: true,
              fromDetailPanel: true,
            }
            changeCurrentTabItem(obj)
          } else {
            getSnackBarToast(data.data.message, 'error')
          }
          setLoading(false)
        } catch (error) {
          setLoading(false)
          getSnackBarToast('Error interno', 'error')
        }

        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleCancelBookings = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al cancelar reservas, no podrás revertir esta acción',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, cancelar reservas',
      confirmButtonColor: 'var(--kt-primary)',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          const data = await deleteBookingBedService(selectedBookings)
          if (!data.data.error) {
            return true
          } else {
            Swal.showValidationMessage(data.data.message)
          }
        } catch (error) {
          Swal.showValidationMessage(`Hubo un error`)
        }
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.close()
        clearSelected()
        getBedBookings()
        setSelectedBookings([])
        getSnackBarToast('Se cancelo reservas con éxito', 'success')
        const obj: TabModel = {
          ...currentTabItem,
          loadingTable: true,
          fromDetailPanel: true,
        }
        changeCurrentTabItem(obj)
      }
    })
  }

  useEffect(() => {
    getBedBookings()
    setSelectedBookings([])
    clearSelected()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    // clearSearchValuesDetail()
    clearSelected()
    setSelectedBookings([])
    getBedBookings()
    // getGuestByFilters()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    if (updateTableDetail) {
      if (pagination.currentPage === 1) {
        clearSelected()
        getBedBookings()
        setSelectedBookings([])
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTableDetail(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTableDetail])

  useEffect(() => {
    if (clearTableDetail) {
      if (pagination.currentPage === 1) {
        clearSelected()
        getBedBookings()
        setSelectedBookings([])
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setClearTableDetail(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTableDetail])

  useEffect(() => {
    if (selected.length > 0) {
      const filteredData = data
        .filter(
          (item) =>
            item.Estado === 'PENDIENTE' ||
            item.Estado === 'ASIGNADA' ||
            item.Estado === 'GENERADA' ||
            item.Estado === 'PRECHECKIN',
        )
        .map((item2) => item2.ReservaCamaId)
      const result = selected.filter((element) => filteredData.includes(element))
      const mappedResult = result.map((item) => ({Id: item}))
      setSelectedBookings(mappedResult)
    } else {
      setSelectedBookings([])
    }
  }, [selected])

  useEffect(() => {
    getBedTypesFn()
    getRoomsTypeFn()
    getDocumentTypesFn()
    getTurnsFn()
    getStatusTypesFn()
    getCampsFilterFn()
    getReceptionistFn(currentTabItem?.objectInfo?.ClienteId, currentTabItem?.objectInfo?.CompaniaId)
    return () => {
      clearSearchValuesDetail()
    }
  }, [])

  const getCampsFilterFn = async () => {
    const data = await getCamps({isCombo: true, siteId: currentTabItem?.objectInfo?.SiteId}, 1)
    setCampsFilter(data)
  }

  const getCampsGuestFn = async (guestId: string) => {
    const response = await getListCampsGuestService(guestId)
    const data = response.data.data || []
    const mappedCamps =
      data.map((item) => ({value: item.CampamentoId, label: item.CampamentoNombre})) || []
    return mappedCamps
  }

  const getModulesFn = async (campamentoId?: string) => {
    const data = await getModulesAvailable({
      CampamentoId: campamentoId,
      FechaIni: currentTabItem.objectInfo.FechaInicio,
      FechaFin: currentTabItem.objectInfo.FechaFin,
    })
    return data
  }

  const getRoomsFn = async (moduloId?: string, campamentoId?: string) => {
    const data = await getRoomsAvailable({
      CampamentoId: campamentoId,
      FechaIni: currentTabItem.objectInfo.FechaInicio,
      FechaFin: currentTabItem.objectInfo.FechaFin,
      ModuloId: moduloId,
    })
    return data
  }

  const getBedsFn = async (roomId?: string, campamentoId?: string) => {
    const data = await getBedsAvailable({
      CampamentoId: campamentoId,
      FechaIni: currentTabItem.objectInfo.FechaInicio,
      FechaFin: currentTabItem.objectInfo.FechaFin,
      HabitacionId: roomId,
    })
    return data
  }

  const loadOptions = async (inputValue: string) => {
    try {
      if (inputValue.length < 3) {
        return []
      }
      const {data: response} = await paginationGuestsService({
        pageNumber: 1,
        size: 2000,
        CampamentoId: currentTabItem?.objectInfo?.CampamentoId || null,
        isCombo: true,
        BuscaTexto: inputValue,
      })
      if (!response.error) {
        const mappedGuests = response.data?.map((guest) => ({
          value: guest.Id,
          label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno}`,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }

  const loadOptionsFilter = async (inputValue: string) => {
    try {
      if (inputValue.length < 3) {
        return []
      }
      const {data: response} = await paginationGuestsService({
        pageNumber: 1,
        size: 500,
        CampamentoId: currentTabItem?.objectInfo?.CampamentoId || null,
        BuscaTexto: inputValue,
      })
      if (!response.error) {
        const mappedGuests = response.data?.map((guest) => ({
          value: guest.Id,
          label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno}`,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }

  const debouncedLoadOptionsFilter = useMemo(() => {
    const load = async (inputValue: string, callback: any) => {
      if (inputValue.length < 3) {
        callback([])
        return
      }

      try {
        const {data: response} = await paginationGuestsService({
          pageNumber: 1,
          size: 500,
          CampamentoId: currentTabItem?.objectInfo?.CampamentoId || null,
          BuscaTexto: inputValue,
        })

        if (!response.error) {
          const mappedGuests = response.data?.map((guest: any) => ({
            value: guest.Id,
            label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno}`,
          }))

          callback(mappedGuests)
        } else {
          callback([])
        }
      } catch {
        callback([])
      }
    }

    return debounce(load, 500) // ⏳ 500ms
  }, [currentTabItem])

  useEffect(() => {
    return () => {
      debouncedLoadOptionsFilter.clear()
    }
  }, [debouncedLoadOptionsFilter])

  const currentTabItemRef = useRef(currentTabItem)

  useEffect(() => {
    currentTabItemRef.current = currentTabItem
  }, [currentTabItem])

  const debouncedLoadOptions = useMemo(() => {
    const load = (inputValue: string, callback: any) => {
      console.log('inputValue', inputValue)
      if (!inputValue || inputValue.length < 3) {
        callback([])
        return
      }

      const loadOptions = async () => {
        try {
          const {data: response} = await paginationGuestsService({
            pageNumber: 1,
            size: 2000,
            CampamentoId: currentTabItemRef.current?.objectInfo?.CampamentoId || null,
            isCombo: true,
            BuscaTexto: inputValue,
          })

          if (!response.error && response.data) {
            const mappedGuests = response.data
              .filter((guest: any) => guest && guest.Id)
              .map((guest: any) => {
                const nombres = guest.Nombres || ''
                const apellidoPaterno = guest.ApellidoPaterno || ''
                const apellidoMaterno = guest.ApellidoMaterno || ''
                const label =
                  `${nombres} ${apellidoPaterno} ${apellidoMaterno}`.trim() || 'Sin nombre'

                return {
                  value: guest.Id,
                  label: label,
                }
              })

            if (callback && typeof callback === 'function') {
              callback(mappedGuests)
            }
          } else {
            if (callback && typeof callback === 'function') {
              callback([])
            }
          }
        } catch (error) {
          console.error('Error fetching options:', error)
          if (callback && typeof callback === 'function') {
            callback([])
          }
        }
      }

      loadOptions()
    }

    return debounce(load, 500)
  }, [])

  useEffect(() => {
    return () => {
      if (debouncedLoadOptions && typeof debouncedLoadOptions.clear === 'function') {
        debouncedLoadOptions.clear()
      }
    }
  }, [debouncedLoadOptions])

  const handleChangeCamp = (value: any, row: BedBookingModel) => {
    setData((prevData: any) =>
      prevData.map((item: any) => {
        if (item.ReservaCamaId === row.ReservaCamaId) {
          return {
            ...item,
            CampamentoId: value.value,
            Campamento: value.label,
            ModuloId: null,
            HabitacionId: null,
            CodigoCama: null,
          }
        }
        return item
      }),
    )
  }

  const handleChangeModule = (value: any, row: BedBookingModel) => {
    setData((prevData: any) =>
      prevData.map((item: any) => {
        if (item.ReservaCamaId === row.ReservaCamaId) {
          return {
            ...item,
            ModuloId: value.value,
            Modulo: value.label,
            HabitacionId: null,
            CodigoCama: null,
          }
        }
        return item
      }),
    )
  }
  const handleChangeRoom = (value: any, row: BedBookingModel) => {
    setData((prevData: any) =>
      prevData.map((item: any) => {
        if (item.ReservaCamaId === row.ReservaCamaId) {
          return {...item, HabitacionId: value.value, Habitacion: value.label, CodigoCama: null}
        }
        return item
      }),
    )
  }
  const handleChangeBeds = (value: any, row: any) => {
    setData((prevData: any) =>
      prevData.map((item: any) => {
        if (item.ReservaCamaId === row.ReservaCamaId) {
          return {...item, CamaId: value.value, CodigoCama: value.label}
        }
        return item
      }),
    )
    if (value !== row) {
      Swal.fire({
        title: '¿Estás seguro de modificar la información?',
        text: '',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si',
        confirmButtonColor: 'var(--kt-primary)',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const data = await updateReserveDetail({
              ReservaCamaId: row.ReservaCamaId,
              CamaId: value.value,
            })
            if (!data.data.error) {
              getBedBookings()
              setSelectedBookings([])
              clearSelected()
              getSnackBarToast('Se asignó con éxito', 'success')
              const obj: TabModel = {
                ...currentTabItem,
                loadingTable: true,
                fromDetailPanel: true,
              }
              changeCurrentTabItem(obj)
              Swal.close()
            } else {
              getSnackBarToast(data.data.message, 'error')
            }
            setLoading(false)
          } catch (error) {
            setLoading(false)
            getSnackBarToast('Error interno', 'error')
          }
        }
      })
    }
  }
  const columns: Column<BedBookingModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelect={true} />,
        id: 'selection',
        Cell: ({...props}) =>
          props.row.original.Estado === 'ASIGNADA' ||
          props.row.original.Estado === 'GENERADA' ||
          props.row.original.Estado === 'PENDIENTE' ||
          props.row.original.Estado === 'PRECHECKIN' ? (
            <KTableSelectionCell id={props.data[props.row.index].ReservaCamaId} />
          ) : (
            <></>
          ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Huésped'
            size='250px'
            name='HuespedId'
            selectLabel='HuespedLabel'
            selecteableAsync
            loadOptions={debouncedLoadOptionsFilter as any}
            placeholder='Busca un Huésped...'
            fromDetail
          />
        ),
        id: 'HuespedId',
        Cell: ({...props}) => {
          const isDisabled =
            props.row.original.Estado === 'CHECK IN' || props.row.original.Estado === 'CHECK OUT'
          return (
            <div>
              <AsyncSelect
                cacheOptions
                defaultOptions={false}
                loadOptions={isDisabled ? undefined : (debouncedLoadOptions as any)}
                styles={style}
                noOptionsMessage={() => 'No hay resultados'}
                isDisabled={isDisabled}
                isLoading={false}
                value={
                  props.row.original.HuespedId
                    ? {
                        value: props.row.original.HuespedId,
                        label: props.row.original.HuespedDescripcion,
                      }
                    : null
                }
                onChange={(event: any) => handleChangeGuest(event, props.data[props.row.index])}
                placeholder='Busca un huesped...'
              />
            </div>
          )
        },
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name='CampamentoId'
            selecteable
            fromDetail
            data={campsFilter}
          />
        ),
        accessor: 'Campamento',
        Cell: ({...props}) => {
          const [campOptions, setCampOptions] = useState([])
          const guestId = props.row.original.HuespedId
          const status = props.row.original.Estado
          useEffect(() => {
            const fetchCamps = async () => {
              if (guestId) {
                try {
                  const data = await getCampsGuestFn(guestId)
                  setCampOptions(data as any)
                } catch (error) {
                  console.error('Error al cargar campamentos:', error)
                }
              }
            }
            if (status !== 'CHECK OUT' && status !== 'CHECK IN') {
              fetchCamps()
            }
          }, [guestId, status])
          return (
            <div style={{width: '200px'}}>
              <Select
                styles={style}
                noOptionsMessage={() => 'No hay resultados'}
                value={
                  props.row.original.CampamentoId
                    ? {
                        value: props.row.original.CampamentoId,
                        label: props.row.original.Campamento,
                      }
                    : null
                }
                options={campOptions as any}
                onChange={(option: any) => handleChangeCamp(option, props.row.original)}
                isDisabled={
                  props.row.original.Estado === 'CHECK IN' ||
                  props.row.original.Estado === 'CHECK OUT'
                }
              />
            </div>
          )
        },
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Módulo'
            searcheable
            name='CodigoModulo'
            fromDetail
          />
        ),
        accessor: 'Modulo',
        Cell: ({...props}) => {
          const [moduleOptions, setModuleOptions] = useState([])
          const campamentoId = props.row.original.CampamentoId
          const status = props.row.original.Estado
          useEffect(() => {
            const fetchModules = async () => {
              if (campamentoId) {
                try {
                  const data = await getModulesFn(campamentoId)
                  setModuleOptions(data as any)
                } catch (error) {
                  console.error('Error al cargar modulos:', error)
                }
              }
            }
            if (status !== 'CHECK OUT' && status !== 'CHECK IN') {
              fetchModules()
            }
          }, [campamentoId, status])
          return (
            <div style={{width: '200px'}}>
              <Select
                styles={style}
                noOptionsMessage={() => 'No hay resultados'}
                value={
                  props.row.original.ModuloId
                    ? {
                        value: props.row.original.ModuloId,
                        label: props.row.original.Modulo,
                      }
                    : null
                }
                options={moduleOptions as any}
                onChange={(option: any) => handleChangeModule(option, props.row.original)}
                isDisabled={
                  props.row.original.Estado === 'CHECK IN' ||
                  props.row.original.Estado === 'CHECK OUT'
                }
              />
            </div>
          )
        },
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Habitación'
            searcheable
            name='CodigoHabitacion'
            fromDetail
          />
        ),
        accessor: 'Habitacion',
        Cell: ({...props}) => {
          const [roomOptions, setRoomOptions] = useState([])
          const moduloid = props.row.original.ModuloId
          const status = props.row.original.Estado

          const campamentoId = props.row.original.CampamentoId
          useEffect(() => {
            const fetchRooms = async () => {
              if (moduloid) {
                try {
                  const data = await getRoomsFn(moduloid, campamentoId)
                  setRoomOptions(data as any)
                } catch (error) {
                  console.error('Error al cargar habitaciones:', error)
                }
              }
            }
            if (status !== 'CHECK OUT' && status !== 'CHECK IN') {
              fetchRooms()
            }
          }, [moduloid, status])
          return (
            <div style={{width: '200px'}}>
              <Select
                styles={style}
                noOptionsMessage={() => 'No hay resultados'}
                value={
                  props.row.original.HabitacionId
                    ? {
                        value: props.row.original.HabitacionId,
                        label: props.row.original.Habitacion,
                      }
                    : null
                }
                options={roomOptions}
                placeholder='Selecciona una habitacion...'
                onChange={(option: any) => handleChangeRoom(option, props.row.original)}
                isDisabled={
                  props.row.original.Estado === 'CHECK IN' ||
                  props.row.original.Estado === 'CHECK OUT'
                }
              />
            </div>
          )
        },
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Cama'
            searcheable
            name='CodigoCama'
            fromDetail
          />
        ),
        accessor: 'CodigoCama',
        Cell: ({...props}) => {
          const [bedOptions, setRoomOptions] = useState([])
          const roomId = props.row.original.HabitacionId
          const status = props.row.original.Estado
          const campamentoId = props.row.original.CampamentoId
          useEffect(() => {
            const fetchBeds = async () => {
              if (roomId) {
                try {
                  const data = await getBedsFn(roomId, campamentoId)
                  setRoomOptions(data as any)
                } catch (error) {
                  console.error('Error al cargar habitaciones:', error)
                }
              }
            }
            if (status !== 'CHECK OUT' && status !== 'CHECK IN') {
              fetchBeds()
            }
          }, [roomId, status])
          return (
            <div style={{width: '200px'}}>
              <Select
                styles={style}
                noOptionsMessage={() => 'No hay resultados'}
                value={
                  props.row.original.CodigoCama
                    ? {
                        value: props.row.original.CamaId,
                        label: props.row.original.CodigoCama,
                      }
                    : null
                }
                options={bedOptions}
                onChange={(option: any) => handleChangeBeds(option, props.row.original)}
                placeholder='Selecciona una cama...'
                isDisabled={
                  props.row.original.Estado === 'CHECK IN' ||
                  props.row.original.Estado === 'CHECK OUT'
                }
              />
            </div>
          )
        },
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nro Doc.'
            name='NroDocumento'
            searcheable
            fromDetail
          />
        ),
        accessor: 'NroDoc',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo Huésped' />,
        accessor: 'TipoHuespedNombre',
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Razon Social'
            name={'RazSoc_Contratista'}
            searcheable
            fromDetail
          />
        ),
        accessor: 'RazonSocialContratista',
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha Inicio'
            dateable
            name='FechaIni'
            fromDetail
          />
        ),
        accessor: 'FechaInicio',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Fin' dateable name='FechaFin' fromDetail />
        ),
        accessor: 'FechaFin',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha Check In'
            dateable
            name='FechaCheckIn'
            fromDetail
          />
        ),
        accessor: 'FechaCheckIn',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha Check Out'
            dateable
            name='FechaCheckOut'
            fromDetail
          />
        ),
        accessor: 'FechaCheckOut',
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado de Reserva'
            fromDetail
            selecteable
            name='EstadoReservaCamaId'
            data={statusType}
          />
        ),
        accessor: 'Estado',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Cama'
            selecteable
            data={bedTypes}
            name='TipoCamaId'
            fromDetail
          />
        ),
        accessor: 'CamaTipo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo Doc.'
            name='TipoDoc'
            selecteable
            data={documentTypes}
            fromDetail
          />
        ),
        accessor: 'TipoDocDescripcion',
      },

      {
        Header: (props) => <KTableHeader tableProps={props} title='Nro de Cama Caliente' />,
        accessor: 'NumeroCamaCaliente',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Piso' />,
        accessor: 'Nivel_descripcion',
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Habitación'
            selecteable
            data={roomType}
            name='TipoHabitacionId'
            fromDetail
          />
        ),
        accessor: 'TipoHabitacion_descripcion',
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Empresa Lotización'
            selecteable
            data={receptionistComp}
            name={'EmpresaLotizacionId'}
            fromDetail
          />
        ),
        accessor: 'EmpresaLotizacionNombre',
        Cell: ({...props}) => (
          <div>
            {!props.row.original.EmpresaLotizacionNombre
              ? 'CUALQUIERA'
              : props.row.original.EmpresaLotizacionNombre}
          </div>
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Turno'
            name={'TurnoId'}
            selecteable
            data={turns}
            fromDetail
          />
        ),
        accessor: 'TurnoNombre',
        Cell: ({...props}) => (
          <div>
            {!props.row.original.TurnoNombre ? 'CUALQUIERA' : props.row.original.TurnoNombre}
          </div>
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='RUC'
            name={'RUC_Contratista'}
            searcheable
            fromDetail
          />
        ),
        accessor: 'RucContratista',
      },
    ],
    [
      bedTypes,
      roomType,
      documentTypes,
      turns,
      statusType,
      receptionistComp,
      data,
      selected,
      campsFilter,
    ],
  )

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex justify-content-end p-2 me-5'>
          <button
            className='btn btn-primary me-3'
            disabled={selectedBookings.length < 1}
            onClick={handleCancelBookings}
            type='button'
          >
            Cancelar Reservas
          </button>
        </div>
        <KTable data={data} columns={columns as any} fromDetail />
        {loading ? <KTableLoading title='Cargando...' /> : null}
      </KTCard>
    </>
  )
}

const TableBookingDetailsWrapper = () => {
  const {isAllowed} = useHoteleria()
  return (
    <KTableProvider>
      {isAllowed('HUESPED/LISTAR') && <TableBookingDetails />}
      <SnackbarProvider />
    </KTableProvider>
  )
}

export {TableBookingDetailsWrapper}
